import { ForwardedRef, useCallback, useRef, useState } from 'react';

import { useDebounceCallback } from '../libs';

import { useResizeObserver } from './useResizeObserver';

type Size = {
  width?: number;
  height?: number;
};

type Result<TElement> = {
  elementRef: ForwardedRef<TElement>;
  height: number | undefined;
};

type Props = {
  debounceMs?: number;
  skip?: boolean;
};

const useElementHeight = <TElement extends HTMLElement = HTMLDivElement>({
  debounceMs = 50,
  skip = false,
}: Props = {}): Result<TElement> => {
  const elementRef = useRef<TElement>(null);
  const [height, setHeight] = useState<number>();

  const handleResizeChange = useCallback((size: Size) => {
    setHeight(size.height);
  }, []);

  const handleResizeDebounced = useDebounceCallback(
    handleResizeChange,
    debounceMs,
  );

  useResizeObserver({
    ref: elementRef,
    onResize: handleResizeDebounced,
    box: 'border-box',
    skip,
  });

  return { height, elementRef };
};

export default useElementHeight;
